import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import PropTypes from 'prop-types';
import { experimentalStyled } from '@mui/material/styles';
import AccountPopover from './AccountPopover';
import Logo from 'components/Logo';
import { Menu } from '@mui/icons-material';

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  boxShadow: 'none',
  color: theme.palette.primary.contrastText,
  zIndex: theme.zIndex.drawer + 100
}));

const DashboardNavbar = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton
          color="inherit"
          onClick={onSidebarMobileOpen}
          sx={{
            display: {
              lg: 'none'
            }
          }}
          size="large"
        >
          <Menu fontSize="small" />
        </IconButton>
        <Box component={RouterLink} to="/" sx={{ textDecoration: "none" }}>
          <Logo
            sx={{
              display: {
                lg: 'inline',
                xs: 'none'
              },
              height: 40,
            }}
          />
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DashboardNavbar;
